import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const omsDisabledSchema = z.object({ omsEnabled: z.literal(false) });

const omsEnabledSchema = z.object({
  omsEnabled: z.literal(true),
  croShippingMethodNameSet: z.array(z.string()),
  omsAutomationsWithRequestedServiceCondition: z.array(
    z.object({ name: z.string(), _id: zExt.objectId() }),
  ),
  omsViewsWithRequestedServiceFilter: z.array(
    z.object({ name: z.string(), _id: zExt.objectId() }),
  ),
});

const outputSchema = z.union([omsDisabledSchema, omsEnabledSchema]);

export const getOmsShippingMethodNameConsiderations = {
  name: "getOmsShippingMethodNameConsiderations" as const,
  input: z.null(),
  output: outputSchema,
};

export type GetOmsShippingMethodNameConsiderationsOutput = z.infer<
  typeof getOmsShippingMethodNameConsiderations.output
>;
